import { render } from "./YesNo.vue?vue&type=template&id=ff4a70da&scoped=true"
import script from "./YesNo.vue?vue&type=script&lang=js"
export * from "./YesNo.vue?vue&type=script&lang=js"

import "./YesNo.vue?vue&type=style&index=0&id=ff4a70da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4a70da"]])

export default __exports__